<template>
    <div id="app">
        <b-container fluid>
            <hw-navbar v-if='showHeaderFooter'></hw-navbar>
        </b-container>
        <b-container :style='contentRegionTopStyle' class='content-region' fluid>
            <router-view/>
            <hw-footer v-if='showHeaderFooter'/>
        </b-container>
    </div>
</template>

<script>
import NavBar from './components/NavBar'
import Footer from './components/Footer'
import DataService from './mixins/dataService'
import Login from './components/Login'

export default {
    mixins: [DataService],
    name: 'app',
    components: {
        'hw-navbar': NavBar,
        'hw-footer': Footer,
        'hw-login': Login
    },
    mounted: function() {
        if (this.authUser.UserID === 0) {
            let userString = window.localStorage.getItem('user')
            if (userString) {
                let user = JSON.parse(userString)
                if (user.UserID) {
                    this.validateUser(user).then(resp => {
                        let validatedUser = resp.data
                        if (validatedUser) {
                            this.$store.commit('setAuthUser', validatedUser)
                            this.getUserSettings(user.UserID, user.LoginToken).then(resp => {
                                // console.log('Returning user, loading settings, userID: ' + user.UserID + ', settings: ' + JSON.stringify(resp.data))
                                this.$store.commit('setAuthUserSettings', resp.data)
                            })
                        }
                    })
                }
            }
        }
    },
    computed: {
        authUser: function() {
            return this.$store.state.authUser
        },
        authSettings: function() {
            return this.$store.state.authUserSettings
        },
        showLogin: function() {
            return this.$store.state.showLogin
        },
        pageTitle() {
            return this.$store.state.head.title
        },
        showHeaderFooter: function() {
            return this.$store.state.showHeaderFooter
        },
        contentRegionTopStyle: function() {
            return this.showHeaderFooter ? '' : 'padding-top: 0'
        }
    },
    watch: {
        pageTitle() {
            if (!this.$isServer) {
                document.title = 'Handweaving.net: ' + this.$store.state.head.title
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/App.vue